import { render, staticRenderFns } from "./UpLevelDialog.vue?vue&type=template&id=a64ce86a&scoped=true"
import script from "./UpLevelDialog.vue?vue&type=script&lang=js"
export * from "./UpLevelDialog.vue?vue&type=script&lang=js"
import style0 from "./UpLevelDialog.vue?vue&type=style&index=0&id=a64ce86a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ce86a",
  null
  
)

export default component.exports